// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"0c8182cb","320":"a63c1d2c","737":"ac1dc71a","770":"789f14cd","787":"064e410b","994":"72bfd2a3"}[chunkId] + ".chunk.js";
};